import React from 'react'

export default function RTKlogo() {
  return (
    <div className="logo">
    <svg width="14rem" x="0px" y="0px" viewBox="0 0 744.5 151.6">
      <path
        fill="#ffffff"
        d="M138.2,3.7c7.7,0,15,1.5,21.9,4.4s12.8,7,17.9,12.1C183,25.2,187,31.2,190,38s4.4,14.1,4.4,21.9
                    c0,7.7-1.5,15-4.4,21.9s-7,12.8-12.1,17.9s-11.1,9.1-17.9,12.1s-14.1,4.4-21.9,4.4c-7.8,0-15.1-1.5-21.9-4.4
                    c-6.8-2.9-12.8-7-17.8-12.1c-5.1-5.1-9.1-11.1-12.1-17.9c-2.9-6.8-4.4-14.1-4.4-21.9c0-7.7,1.5-15,4.4-21.9s7-12.8,12.1-17.9
                    c5.1-5.1,11-9.1,17.8-12C123,5.1,130.3,3.7,138.2,3.7z M138.2,104.8c6.2,0,12.1-1.2,17.5-3.5c5.4-2.3,10.2-5.6,14.2-9.7
                    c4.1-4,7.4-8.8,9.7-14.2c2.3-5.4,3.5-11.3,3.5-17.5s-1.2-12.1-3.5-17.5s-5.6-10.2-9.7-14.2c-4-4.1-8.8-7.4-14.2-9.7
                    c-5.4-2.3-11.3-3.5-17.5-3.5s-12.1,1.2-17.5,3.5s-10.2,5.5-14.2,9.7c-4.1,4-7.3,8.8-9.7,14.2s-3.5,11.3-3.5,17.5s1.2,12.1,3.5,17.5
                    c2.3,5.4,5.6,10.2,9.7,14.2c4,4.1,8.8,7.3,14.2,9.7C126.1,103.6,131.9,104.8,138.2,104.8z"
      />
      <path fill="#ffffff" d="M158.9,37.9l7.3,7.3l-37.7,36.6l-18.8-20l6.9-7l12.9,12.8L158.9,37.9z" />
      <path
        fill="#ffffff"
        d="M77.3,85.2H16.8V74.9h57c-0.8-3.4-1.3-6.9-1.6-10.5H16.8V54h55.6c0.4-3.5,1-7,1.9-10.3H16.8V33.4h61.5
                    C85.7,18.1,99.2,6.2,115.6,1H2v118.8h28.1V150l36.4-30.3h49.1C98.3,114.3,84.4,101.6,77.3,85.2z"
      />
      <path
        fill="#ffffff"
        d="M229.4,32.7v16.7h-6.8V7.7h11.8c5.4,0,9.4,1,12,3c2.6,2,3.9,5.1,3.9,9.1c0,5.2-2.7,8.9-8.1,11.1l11.8,18.4h-7.8
                    l-10-16.7L229.4,32.7L229.4,32.7z M229.4,27.1h4.7c3.2,0,5.5-0.6,6.9-1.8s2.1-2.9,2.1-5.2c0-2.4-0.8-4-2.3-5.1s-3.9-1.5-7-1.5h-4.5
                    L229.4,27.1L229.4,27.1z"
      />
      <path fill="#ffffff" d="M284.2,49.4h-23.6V7.7h23.6v5.8h-16.8v11.4h15.7v5.7h-15.7v13.1h16.8L284.2,49.4L284.2,49.4z" />
      <path
        fill="#ffffff"
        d="M319.7,49.4l-4.2-11.6h-15.9l-4.1,11.6h-7.2L304,7.5h7.4L327,49.4H319.7z M313.8,31.9l-3.9-11.4
                    c-0.3-0.8-0.7-2-1.2-3.6s-0.9-2.8-1-3.6c-0.5,2.3-1.3,4.9-2.2,7.7l-3.8,10.9H313.8z"
      />
      <path fill="#ffffff" d="M333.2,49.4V7.7h6.8v35.8h17.6v5.8C357.6,49.4,333.2,49.4,333.2,49.4z" />
      <path fill="#ffffff" d="M379.9,49.4h-6.8V13.6h-12.3V7.7h31.3v5.8h-12.3L379.9,49.4L379.9,49.4z" />
      <path fill="#ffffff" d="M399.3,49.4V7.7h6.8v41.7H399.3z" />
      <path
        fill="#ffffff"
        d="M435.8,49.4l-12.1-34.8h-0.2c0.3,5.2,0.5,10,0.5,14.5v20.3h-6.2V7.7h9.6L439,40.9h0.2l11.9-33.2h9.6v41.7h-6.6
                    V28.8c0-2.1,0-4.8,0.2-8.1c0.1-3.3,0.2-5.3,0.3-6h-0.2l-12.5,34.8H435.8z"
      />
      <path fill="#ffffff" d="M496,49.4h-23.6V7.7H496v5.8h-16.8v11.4h15.7v5.7h-15.7v13.1H496V49.4z" />
      <path fill="#ffffff" d="M251,119.5h-3.6l-16-22l-5.6,4.9v17.1H223V77.8h2.9v21.7l4.6-4.6l16.3-17h3.7l-17.1,17.6L251,119.5z" />
      <path
        fill="#ffffff"
        d="M287.9,119.5H285l-24.7-37H260c0.2,4.4,0.3,7.7,0.3,10v27h-2.8V77.8h2.9l24.7,36.9h0.2
                    c-0.2-3.4-0.3-6.7-0.3-9.8V77.8h2.8L287.9,119.5L287.9,119.5z"
      />
      <path
        fill="#ffffff"
        d="M335.5,98.6c0,6.6-1.6,11.8-5,15.7s-7.9,5.8-13.7,5.8c-5.8,0-10.4-1.9-13.7-5.8s-5-9.1-5-15.8
                    c0-6.6,1.7-11.9,5-15.7s7.9-5.7,13.7-5.7c5.8,0,10.4,1.9,13.7,5.8C333.8,86.7,335.5,91.9,335.5,98.6z M301.4,98.6
                    c0,6,1.3,10.6,4,13.8s6.5,4.9,11.5,4.9c5,0,8.9-1.6,11.5-4.8c2.6-3.2,4-7.9,4-13.9c0-6-1.3-10.6-4-13.8c-2.6-3.2-6.5-4.8-11.5-4.8
                    c-5,0-8.8,1.6-11.5,4.8C302.7,88,301.4,92.6,301.4,98.6z"
      />
      <path
        fill="#ffffff"
        d="M379,119.5h-2.4l-9.1-32.2c-0.8-2.6-1.3-4.8-1.7-6.5c-0.3,1.7-0.7,3.6-1.3,5.7c-0.6,2.2-3.6,13.1-9.2,33h-2.5
                    l-11.5-41.7h3l7.3,26.9c0.3,1.1,0.5,2.1,0.8,3c0.2,0.9,0.5,1.8,0.7,2.6s0.4,1.6,0.5,2.3s0.3,1.5,0.4,2.3c0.5-2.6,1.4-6.5,2.9-11.8
                    l7.1-25.3h3.2l8.4,29c1,3.3,1.7,6,2.1,8.1c0.2-1.4,0.6-2.8,1-4.4c0.4-1.5,3.3-12.5,8.8-32.8h2.9L379,119.5z"
      />
      <path fill="#ffffff" d="M398.5,119.5V77.8h2.9v38.9h19.9v2.7H398.5z" />
      <path fill="#ffffff" d="M452,119.5h-22.8V77.8H452v2.7h-19.9v15.8h18.8v2.7h-18.8v17.9H452V119.5z" />
      <path
        fill="#ffffff"
        d="M493.8,98.2c0,7-1.8,12.3-5.5,15.9s-9.1,5.4-16.2,5.4h-10V77.8h11.3c6.6,0,11.7,1.7,15.2,5.2
                    S493.8,91.5,493.8,98.2z M490.6,98.3c0-6-1.5-10.5-4.5-13.5s-7.5-4.5-13.4-4.5H465v36.5h6.9C484.4,116.9,490.6,110.7,490.6,98.3z"
      />
      <path
        fill="#ffffff"
        d="M520.4,98.5h15.4v19c-4,1.7-8.6,2.6-13.6,2.6c-6.6,0-11.6-1.9-15.1-5.6c-3.5-3.7-5.3-9-5.3-15.8
                    c0-4.2,0.9-8,2.6-11.3s4.2-5.8,7.5-7.6s7-2.7,11.2-2.7c4.5,0,8.6,0.8,12.2,2.5l-1.2,2.6c-3.6-1.7-7.4-2.5-11.2-2.5
                    c-5.5,0-9.8,1.7-13.1,5.1c-3.2,3.4-4.8,8-4.8,13.7c0,6.3,1.5,11,4.6,14.2s7.6,4.8,13.5,4.8c3.8,0,7.1-0.5,9.8-1.6v-14.7h-12.4
                    L520.4,98.5L520.4,98.5z"
      />
      <path fill="#ffffff" d="M569.8,119.5H547V77.8h22.8v2.7h-19.9v15.8h18.8v2.7h-18.8v17.9h19.9V119.5z" />
      <path
        fill="#ffffff"
        d="M578.6,117.2c0-1.9,0.8-2.8,2.3-2.8c1.6,0,2.3,0.9,2.3,2.8s-0.8,2.8-2.3,2.8C579.4,120,578.6,119.1,578.6,117.2
                    z"
      />
      <path
        fill="#ffffff"
        d="M612.3,79.8c-5.2,0-9.3,1.7-12.3,5c-3,3.3-4.5,7.9-4.5,13.7c0,5.9,1.4,10.6,4.2,13.9s6.9,4.9,12.2,4.9
                    c3.5,0,6.7-0.4,9.6-1.3v2.6c-2.8,1-6.2,1.4-10.3,1.4c-5.9,0-10.5-1.9-13.8-5.7s-5-9.1-5-15.8c0-4.2,0.8-8,2.4-11.2
                    c1.6-3.2,3.9-5.7,6.9-7.5c3-1.8,6.5-2.6,10.5-2.6c4.1,0,7.7,0.8,10.9,2.3l-1.2,2.6C618.8,80.6,615.6,79.8,612.3,79.8z"
      />
      <path
        fill="#ffffff"
        d="M666.5,98.6c0,6.6-1.7,11.8-5,15.7s-7.9,5.8-13.7,5.8c-5.8,0-10.3-1.9-13.7-5.8s-5-9.1-5-15.8
                    c0-6.6,1.7-11.9,5-15.7s7.9-5.7,13.7-5.7c5.8,0,10.4,1.9,13.7,5.8C664.8,86.7,666.5,91.9,666.5,98.6z M632.4,98.6
                    c0,6,1.3,10.6,4,13.8s6.5,4.9,11.5,4.9c5,0,8.8-1.6,11.5-4.8c2.7-3.2,4-7.9,4-13.9c0-6-1.3-10.6-4-13.8c-2.7-3.2-6.5-4.8-11.5-4.8
                    c-5,0-8.8,1.6-11.5,4.8C633.7,88,632.4,92.6,632.4,98.6z"
      />
      <path
        fill="#ffffff"
        d="M695.1,119.5L679.6,81h-0.2c0.2,2.4,0.2,4.8,0.2,7.2v31.3h-2.8V77.8h4.5l14.8,36.7h0.2L711,77.8h4.4v41.7h-2.9
                    V87.9c0-2.2,0.1-4.5,0.3-6.8h-0.2l-15.6,38.4H695.1z"
      />
      <path
        fill="#ffffff"
        d="M727.4,78.8v9.4h-1.9v-9.4h-3.5v-1.7h9v1.7H727.4z M737.8,86.8l-3.2-7l0.1,8.3h-1.8v-11h2.4l3.4,7.5l3.4-7.5
                    h2.4v11h-1.8l0.1-8.3l-3.2,7H737.8z"
      />
    </svg>
  </div>
  )
}
